module.exports = __webpack_public_path__ + "img/durban's-super-giants-logo-icon.c8795e23.png";